import { render, staticRenderFns } from "./BooleanType.vue?vue&type=template&id=331fb108&"
import script from "./BooleanType.vue?vue&type=script&lang=js&"
export * from "./BooleanType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports